/* ==========================================================================
   Polokom Blue — theme.js
   ========================================================================== */
(function () {
  'use strict';

  var T = window.Theme || {};
  var routes = T.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  // Shopify'ın dört para birimi yer tutucusunu da destekler; aksi hâlde
  // TL formatı ({{amount_with_comma_separator}}) kullanan mağazalarda
  // JS ile güncellenen fiyatlar boş kalıyordu.
  // KDV dahil tutar (kuruş). Oran snippets/kdv-rate.liquid'den Theme.kdvRate ile gelir.
  function grossCents(cents) {
    var rate = parseFloat(T.kdvRate);
    if (isNaN(rate)) rate = 20;
    return Math.round(cents * (1 + rate / 100));
  }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var int = parts[0];
    var dec = parts[1];

    function group(sep) {
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount': return group(',') + '.' + dec;
        case 'amount_no_decimals': return group(',');
        case 'amount_with_comma_separator': return group('.') + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return group('.');
        case 'amount_with_apostrophe_separator': return group("'") + '.' + dec;
        case 'amount_no_decimals_with_space_separator': return group(' ');
        case 'amount_with_space_separator': return group(' ') + ',' + dec;
        default: return group('.') + ',' + dec;
      }
    });
  }

  /* ---------- 1. Drawers ---------- */
  var lastFocus = null;

  function openDrawer(name) {
    var d = document.querySelector('[data-drawer="' + name + '"]');
    if (!d) return;
    lastFocus = document.activeElement;
    d.setAttribute('data-open', 'true');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = d.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeDrawers() {
    $$('[data-drawer]').forEach(function (d) {
      d.setAttribute('data-open', 'false');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); openDrawer(openBtn.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawers();
    var panel = $('[data-facets]');
    var overlay = $('.facets__overlay');
    if (panel) panel.setAttribute('data-open', 'false');
    if (overlay) overlay.setAttribute('data-open', 'false');
    var results = $('[data-search-results]');
    if (results) results.setAttribute('data-open', 'false');
  });

  /* ---------- 2. Mobil menü akordeon ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mnav-toggle]');
    if (!t) return;
    var expanded = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!expanded));
    var sub = t.closest('.mnav__item').querySelector('[data-mnav-sub]');
    if (sub) sub.setAttribute('data-open', String(!expanded));
  });

  /* ---------- 3. Adet kutusu ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-qty]');
    var input = wrap.querySelector('input');
    var v = parseInt(input.value, 10) || 0;
    var min = parseInt(input.getAttribute('min'), 10) || 0;
    v = plus ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- 4. Sepet ---------- */
  function refreshCartUI(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    $$('[data-cart-total], [data-cart-subtotal]').forEach(function (el) { el.textContent = formatMoney(grossCents(cart.total_price)); });
  }

  function reloadCartDrawer() {
    return fetch(routes.cart + '?view=drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-cart-drawer-body]');
        var newFoot = doc.querySelector('[data-cart-drawer-foot]');
        var body = $('[data-cart-drawer-body]');
        var foot = $('[data-cart-drawer-foot]');
        if (newBody && body) body.innerHTML = newBody.innerHTML;
        if (newFoot && foot) foot.innerHTML = newFoot.innerHTML;
      })
      .catch(function () { /* sessizce geç */ });
  }

  function addToCart(formData, button) {
    var original = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.textContent = T.strings.adding || '...'; }

    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message);
        return fetch(routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        return reloadCartDrawer();
      })
      .then(function () {
        openDrawer('cart-drawer');
      })
      .catch(function (err) {
        alert(err.message || 'Ürün sepete eklenemedi.');
      })
      .finally(function () {
        if (button) { button.disabled = false; button.innerHTML = original; }
      });
  }

  // Hızlı ekle + ürün formu
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-quick-add], [data-product-form]');
    if (!form) return;
    e.preventDefault();
    // Fiyatı 0 olan varyant satışa kapalı
    if (form.getAttribute('data-price-on-request') === 'true') return;
    addToCart(new FormData(form), form.querySelector('button[type="submit"]'));
  });

  // Sabit sepet çubuğu butonu
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-sticky-atc-btn]')) return;
    var form = $('[data-product-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  // Adet güncelle / satır sil
  function changeLine(line, qty) {
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartUI(cart);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return reloadCartDrawer();
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(parseInt(input.getAttribute('data-line'), 10), parseInt(input.value, 10) || 0);
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line'), 10), 0);
  });

  /* ---------- 4b. Favoriler (localStorage) ----------
     Harici bir favori uygulaması yoksa tarayıcıda saklanır. Bir wishlist
     uygulaması kurulursa bu bloğun yerine onun API'si bağlanabilir. */
  var WISH_KEY = 'polokom_wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISH_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }

  function writeWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) { /* kota dolu / gizli mod */ }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Favori satırı — hem çekmecede hem favoriler sayfasında kullanılır
  function wishRow(item) {
    var img = item.image
      ? '<img class="cart-line__img" src="' + escapeHtml(item.image) + '" alt="" width="72" height="72" loading="lazy">'
      : '<span class="cart-line__img"></span>';

    return '<div class="cart-line">' +
      '<a href="' + escapeHtml(item.url) + '">' + img + '</a>' +
      '<div>' +
        '<h4 class="cart-line__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h4>' +
        (item.price ? '<div class="cart-line__price">' + escapeHtml(item.price) + '</div>' : '') +
        '<button type="button" class="cart-line__remove" data-wish data-wish-id="' + escapeHtml(item.id) + '">' +
          (T.strings.removeFavourite || 'Favorilerden çıkar') +
        '</button>' +
      '</div>' +
      '<div style="text-align:right">' +
        '<a class="btn btn--outline btn--sm" href="' + escapeHtml(item.url) + '">' +
          (T.strings.viewProduct || 'İncele') +
        '</a>' +
      '</div>' +
    '</div>';
  }

  function renderWishlistViews(list) {
    var emptyHtml =
      '<div class="cart-empty">' +
        '<p style="margin-top:14px">' + (T.strings.favouritesEmpty || 'Favori listeniz boş.') + '</p>' +
        '<a class="btn btn--primary" href="' + (routes.root || '/') + 'collections/all">' +
          (T.strings.continueShopping || 'Alışverişe Devam Et') +
        '</a>' +
      '</div>';

    var html = list.length ? list.map(wishRow).join('') : emptyHtml;

    $$('[data-fav-list]').forEach(function (el) { el.innerHTML = html; });
    $$('[data-fav-count-label]').forEach(function (el) { el.textContent = '(' + list.length + ')'; });
    $$('[data-fav-foot]').forEach(function (el) {
      if (list.length) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
  }

  function paintWishlist() {
    var list = readWishlist();
    var ids = list.map(function (i) { return String(i.id); });

    $$('[data-wish]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(ids.indexOf(String(btn.getAttribute('data-wish-id'))) > -1));
    });

    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      if (list.length > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });

    renderWishlistViews(list);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-fav-clear]')) return;
    writeWishlist([]);
    paintWishlist();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = String(btn.getAttribute('data-wish-id'));
    var list = readWishlist();
    var idx = -1;
    list.forEach(function (item, i) { if (String(item.id) === id) idx = i; });

    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push({
        id: id,
        url: btn.getAttribute('data-wish-url') || '',
        title: btn.getAttribute('data-wish-title') || '',
        image: btn.getAttribute('data-wish-image') || '',
        price: btn.getAttribute('data-wish-price') || ''
      });
      btn.classList.add('is-wish-pop');
      setTimeout(function () { btn.classList.remove('is-wish-pop'); }, 320);
    }

    writeWishlist(list);
    paintWishlist();
  });

  paintWishlist();
  window.PolokomWishlist = { get: readWishlist, refresh: paintWishlist };

  /* ---------- 5. Öngörülü arama ---------- */
  $$('search-bar').forEach(function (root) {
    var input = $('[data-search-input]', root);
    var results = $('[data-search-results]', root);
    if (!input || !results) return;
    var timer = null;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.setAttribute('data-open', 'false'); results.innerHTML = ''; return; }

      timer = setTimeout(function () {
        var base = routes.predictiveSearch || '/search/suggest';
        fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { results.innerHTML = '<div style="padding:16px;font-size:13px;color:#6B7C93">Sonuç bulunamadı.</div>'; }
            else {
              results.innerHTML = items.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '<span style="width:48px;height:48px;background:#EDF3FA;border-radius:6px"></span>';
                return '<a class="search__result" href="' + p.url + '">' + img +
                  '<span style="flex:1"><span class="search__result-title">' + p.title + '</span></span>' +
                  '<span class="search__result-price">' + (p.price ? formatMoney(grossCents(parseFloat(p.price) * 100)) : '') + '</span></a>';
              }).join('');
            }
            results.setAttribute('data-open', 'true');
          })
          .catch(function () { results.setAttribute('data-open', 'false'); });
      }, 260);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) results.setAttribute('data-open', 'false');
    });
  });

  /* ---------- 6. Hero slider ---------- */
  $$('hero-slider').forEach(function (root) {
    var track = $('[data-hero-track]', root);
    var slides = $$('.hero__slide', root);
    var dots = $$('[data-hero-dot]', root);
    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var auto = root.getAttribute('data-autoplay') === 'true';

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, idx) { d.setAttribute('aria-current', String(idx === i)); });
    }
    function start() { if (auto) timer = setInterval(function () { go(i + 1); }, interval); }
    function stop() { clearInterval(timer); }

    var next = $('[data-hero-next]', root);
    var prev = $('[data-hero-prev]', root);
    if (next) next.addEventListener('click', function () { stop(); go(i + 1); start(); });
    if (prev) prev.addEventListener('click', function () { stop(); go(i - 1); start(); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { stop(); go(idx); start(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // dokunmatik kaydırma
    var startX = 0;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      start();
    });

    start();
  });

  /* ---------- 6b. Ürün karuseli (oklarla kaydırma) ---------- */
  function setupCarousel(root) {
    var track = $('[data-carousel-track]', root);
    var prev = $('[data-carousel-prev]', root);
    var next = $('[data-carousel-next]', root);
    if (!track) return;

    function page() {
      // Bir "sayfa" = görünen alanın tamamına yakını
      return Math.max(track.clientWidth * 0.9, 200);
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -page(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: page(), behavior: 'smooth' }); });

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    setTimeout(refresh, 60);
  }

  $$('[data-carousel]').forEach(setupCarousel);

  /* ---------- 7. Sekmeler ---------- */
  $$('[data-tabs]').forEach(function (root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab]');
      if (!btn) return;
      var id = btn.getAttribute('data-tab');
      $$('[data-tab]', root).forEach(function (b) { b.setAttribute('aria-selected', String(b === btn)); });
      var scope = root.closest('.section') || document;
      $$('[data-tab-panel]', scope).forEach(function (p) {
        p.hidden = p.getAttribute('data-tab-panel') !== id;
      });
      // Gizliyken genişlik 0 olduğu için karusel oklarını yeniden hesapla
      window.dispatchEvent(new Event('resize'));
    });
  });

  /* ---------- 8. Filtre akordeonu + otomatik gönderim ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-facet-toggle]');
    if (!t) return;
    var expanded = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', String(!expanded));
    var body = t.nextElementSibling;
    if (body) body.hidden = expanded;
  });

  // Mobilde filtre panelini aç/kapat
  document.addEventListener('click', function (e) {
    var panel = $('[data-facets]');
    var overlay = $('.facets__overlay');
    if (!panel) return;

    if (e.target.closest('[data-facets-open]')) {
      panel.setAttribute('data-open', 'true');
      if (overlay) overlay.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
    } else if (e.target.closest('[data-facets-close]')) {
      panel.setAttribute('data-open', 'false');
      if (overlay) overlay.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }
  });

  var facetForm = $('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox') return;
      var params = new URLSearchParams(new FormData(facetForm));
      window.location.search = params.toString();
    });
    facetForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(facetForm));
      window.location.search = params.toString();
    });
  }

  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- 9. Ürün galerisi ----------
     URL'ler her küçük görselin data-full özniteliğinde hazır duruyor;
     JSON çözümlemesi veya URL birleştirme yok. Yükleme başarısız olursa
     önceki görsele dönülür, böylece ana alan hiçbir zaman boş kalmaz. */
  $$('product-gallery').forEach(function (root) {
    var main = $('[data-gallery-main]', root);
    if (!main) return;

    var lastGood = main.getAttribute('src');

    main.addEventListener('load', function () {
      if (main.naturalWidth > 0) lastGood = main.getAttribute('src');
    });

    main.addEventListener('error', function () {
      if (lastGood && main.getAttribute('src') !== lastGood) main.setAttribute('src', lastGood);
    });

    $$('[data-gallery-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) {
          var inner = thumb.querySelector('img');
          full = inner ? inner.getAttribute('src') : null;
        }
        if (!full) return;

        main.setAttribute('src', full);
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');

        $$('[data-gallery-thumb]', root).forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      });
    });
  });

  /* ---------- 10. Varyant seçimi ---------- */
  $$('product-form').forEach(function (root) {
    var dataEl = $('[data-variants]', root);
    var form = $('[data-product-form]', root);
    if (!dataEl || !form) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-pdp-price]');
    var compareEl = $('[data-pdp-compare]');
    var skuEl = $('[data-pdp-sku]');
    var stickyPrice = $('[data-sticky-price]');
    var priceNetEl = $('[data-pdp-price-net]');
    var atc = $('[data-atc]', form);
    var atcText = $('[data-atc-text]', form);

    function selected() {
      return $$('[data-option-index]', form).map(function (group) {
        var active = group.querySelector('[aria-checked="true"]');
        return active ? active.getAttribute('data-option-value') : null;
      });
    }

    function update() {
      var opts = selected();
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });

      if (!match) {
        if (atc) { atc.disabled = true; }
        if (atcText) atcText.textContent = T.strings.unavailable || 'Mevcut değil';
        return;
      }

      if (idInput) idInput.value = match.id;

      // Fiyatı 0 olan varyantta satın alma alanları gizlenir, iletişim gösterilir
      var onRequest = Number(match.price) === 0;
      form.setAttribute('data-price-on-request', String(onRequest));
      $$('[data-price-contact]').forEach(function (el) { el.style.display = onRequest ? '' : 'none'; });
      $$('[data-price-normal], [data-buy-box], [data-dynamic-checkout]').forEach(function (el) { el.style.display = onRequest ? 'none' : ''; });
      if (priceEl) priceEl.textContent = formatMoney(grossCents(match.price));
      if (priceNetEl) priceNetEl.textContent = '(KDV hariç: ' + formatMoney(match.price) + ')';
      if (stickyPrice) stickyPrice.textContent = formatMoney(grossCents(match.price));
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = formatMoney(grossCents(match.compare_at_price));
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (skuEl && match.sku) skuEl.textContent = match.sku;

      if (atc) atc.disabled = !match.available;
      if (atcText) atcText.textContent = match.available ? (T.strings.addToCart || 'Sepete Ekle') : (T.strings.soldOut || 'Tükendi');

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      var group = btn.closest('[data-option-index]');
      $$('[data-option-value]', group).forEach(function (b) { b.setAttribute('aria-checked', String(b === btn)); });
      var label = form.querySelectorAll('[data-option-selected]')[parseInt(group.getAttribute('data-option-index'), 10)];
      if (label) label.textContent = btn.getAttribute('data-option-value');
      update();
    });
  });

  /* ---------- 11. Sabit sepet çubuğu görünürlüğü ---------- */
  var sticky = $('[data-sticky-atc]');
  if (sticky) {
    var buyBox = $('.pdp__buy');
    if (buyBox && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var visible = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.setAttribute('data-visible', String(visible));
        // WhatsApp balonu çubuğun üstüne çıksın
        document.body.classList.toggle('has-sticky-atc', visible);
      }, { threshold: 0 }).observe(buyBox);
    }
  }

  /* ---------- 12. Benzer ürünler (lazy) ---------- */
  var related = $('[data-related-url]');
  if (related) {
    fetch(related.getAttribute('data-related-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('.product-grid');
        if (grid && grid.children.length) {
          related.innerHTML = grid.innerHTML;
          paintWishlist(); // sonradan gelen kartların kalplerini de boya
        } else {
          related.closest('.section').style.display = 'none';
        }
      })
      .catch(function () { });
  }
})();
